export { default as ErrorPage, withErrorPage } from './error-page';
